const DEFAULT = {
    avatar: {
        name: 'Name',
        role: 'Role',
        image: 'https://www.citypng.com/public/uploads/small/11639594308azjskddoutgi296zaayuhyuspofhahhfa4ezuhne7vcflkjlnicxnewkf17enf0janiemum3o1eikv5x9r1s6wst2obumnv3rmxj.png',
    },
    button: {
        text: 'Button',
    },
    content: {
        width: '100%',
    },
    dropdown: {
        country: 'Colombia',
        image: 'https://cdn-icons-png.flaticon.com/512/323/323343.png',
    },
    input: {
        label: 'Label',
        placeholder: 'Placeholder',
        search: 'Buscar'
    },
    modal: {
        title: 'Title Modal',
    },
    navbar: {
        brand: 'MPO',
        image: 'https://landing-emails.s3.us-west-2.amazonaws.com/2021/junio/home-leal.co/logo-leal-home.svg'
    },
    select: {
        defaultOption: 'Seleccione',
    },
    stepper: {
        text: 'Step 1',
        number: '1',
    },
    table: {
        title: 'Title Table',
        lastUpdate: '01/02/2023',
        notRecords: 'No se encontraron resultados',
        allRecords: 'todos',
        textActions: 'Acciones',
        paginator: {
            initial: 0,
            default: 9,
            pages: 10
        }
    },
    uploader: {
        maxFileSize: 1024,
        fileType: 'image.*',
        title: 'Title',
        width: '0',
        height: '0',
        textSize: '1',
        types: ['JPG', 'PNG', 'GIF'],
        textAction: 'Arrastre y suelte su imagen aquí',
        textError: 'Error al subir el archivo',
        textErrorNoFiles: 'Error al subir el archivo',
        textErrorSize: 'La imagen supera el tamaño permitido (max 1 MB)',
        textErrorType: 'Formato de archivo no permitido',
    },
    textArea: {
        id: 'id-text-area',
        rows: 3,
        maxCharacters: 250
    },
};

export { DEFAULT as D };
